import { Link } from "react-router-dom";
import { forecasts, siteInfo } from "@/mocks/forecast";

const stats = [
  { value: "160+", label: "累计前瞻" },
  { value: "28", label: "今日信号" },
  { value: "6", label: "覆盖领域" },
  { value: "3.2万", label: "蹲守订阅" },
];

export default function Hero() {
  const featured = forecasts[0];

  return (
    <section className="relative overflow-hidden bg-background-100">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20backdrop%20of%20soft%20warm%20cream%20paper%20texture%20with%20flowing%20coral%20red%20and%20melon%20green%20geometric%20ribbon%20shapes%2C%20gentle%20grain%2C%20subtle%20glow%2C%20minimal%20modern%20graphic%20composition%2C%20no%20text%2C%20elegant%20magazine%20aesthetic&width=1600&height=1000&seq=gossip-hero-bg-01&orientation=landscape"
        alt="看料大瓜预告前瞻的抽象装饰背景"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-100 via-background-100/90 to-background-100/50" />

      <div className="relative mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute h-2 w-2 animate-ping rounded-full bg-primary-400" />
              <span className="h-2 w-2 rounded-full bg-primary-500" />
            </span>
            瓜田预警 · 每日更新
          </p>

          <h1 className="mt-5 font-heading text-4xl font-black leading-[1.1] tracking-tight text-foreground-950 md:text-6xl">
            看料大瓜
            <span className="mt-2 block text-primary-600">{siteInfo.slogan}</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            {siteInfo.description}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/forecast"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-radar-line text-lg" />
              查看今日预告前瞻
            </Link>
            <Link
              to="/#subscribe"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-6 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
            >
              <i className="ri-notification-3-line text-lg" />
              订阅蹲守提醒
            </Link>
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300 pt-6 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-foreground-500">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <Link
            to={`/forecast/${featured.id}`}
            className="group relative block overflow-hidden rounded-lg border border-background-300 bg-background-50"
          >
            <div className="relative h-56 w-full overflow-hidden md:h-72">
              <img
                src={featured.cover}
                alt={`${featured.title} 前瞻配图`}
                title={`${featured.title} - 看料大瓜预告前瞻`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
              <div className="absolute left-4 top-4 flex items-center gap-2">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold text-background-50">
                  {featured.stage}
                </span>
                <span className="rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-semibold text-foreground-800">
                  {featured.categoryName}
                </span>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="flex items-center gap-2 text-[11px] font-medium text-background-100">
                  <i className="ri-fire-line text-secondary-300" />
                  热度 {featured.heat} · 今日主推
                </p>
                <h2 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                  {featured.title}
                </h2>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                阅读完整前瞻
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}